<template>
  <div class="container-fluid">
    <b-card no-body class="card-transparent-background">
      <b-card-title class="card-title-doom-yoga"> Customer List </b-card-title>
    </b-card>
    <b-overlay
      :show="overlay_show"
      rounded="sm"
      variant="doorder-primary"
      opacity="0.5"
      blur="2px"
    >
      <b-card>
        <b-row class="mb-3">
          <!-- <b-col lg="3">
                <div id="objectTypeSelect" class="">
                  <select
                    id="selectFilterType"
                    data-style="select-with-transition"
                    class="form-control form-control-filter-astrology"
                    name="object_type"
                  >
                    <option value="">Select all object types</option>
                  </select>
                </div>
            </b-col> -->
          <b-col lg="3"
            ><v-select
              class="v-select-doomyoga select-filter"
              :options="levels"
              :clearable="false"
              name="level"
              title="level"
              v-model="level"
              :reduce="(item) => item.code"
              placeholder="Select level"
              required
              @input="changeLevelFilter"
            ></v-select
          ></b-col>
        </b-row>
        <b-table-simple
          class="table table-no-bordered table-hover doomYogaTable"
          id="customersTable"
          hover
          responsive
        >
          <b-thead>
            <b-tr>
              <b-th>Name</b-th>
              <b-th>Email</b-th>
              <b-th>Number</b-th>
              <b-th>Level</b-th>
              <b-th class="text-center">Actions</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr v-for="customer in customers" :key="customer.id">
              <b-td>{{ customer.name }}</b-td>
              <b-td>{{ customer.email }}</b-td>
              <b-td>{{ customer.phone }}</b-td>
              <b-td>{{ customer.profile.level }}</b-td>
              <b-td class="centerTd">
                <router-link
                  :to="'/doom_yoga/customers/edit/' + customer.id"
                  class="btn btn-action-table-doom-yoga mb-1"
                >
                  <img
                    src="@/assets/images/doom-yoga/edit-icon-table.png"
                    alt="edit icon"
                  />
                </router-link>

                <b-button
                  variant="action-table-doom-yoga "
                  class="mb-1"
                  @click="clickDeleteObject(item.id)"
                >
                  <img
                    src="@/assets/images/doom-yoga/delete-icon-table.png"
                    alt="delete icon"
                  />
                </b-button>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";

import Vue from "vue";
import vSelect from "vue-select";
Vue.component("v-select", vSelect);

export default {
  name: "DoomYogaCustomersList",
  components: {},
  data() {
    return {
      customers: [],
      table: null,
      overlay_show: false,
      levels: [{ label: "All levels", code: "" }],
      level: "",
    };
  },
  mounted() {
    // let user = JSON.parse(window.localStorage.getItem("user"));
    // console.log(user);
    // console.log(user.id, user.title);
    // this.user_id = user.id;
    // this.user_title = user.type;
    // // this.getOrders(user.id);
    // console.log(this.user_title);
    // console.log(this.user_title);
    this.overlay_show = true;
    let temp = this;
    setTimeout(function () {
      temp.initTable();
      temp.getCustomersList();
    }, 1000);
  },
  methods: {
    getCustomersList() {
      console.log("here call customers list");
      // console.log(JSON.parse(window.localStorage.getItem("user")).access_token);

      axios
        .get("/admin/users", {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: "DY",
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          if (this.table != null) {
            this.table.destroy();
          }
          console.log(response);
          this.customers = response.data;
          var temp = this;
          setTimeout(function () {
            temp.initTable();
          }, 1000);
          temp.overlay_show = false;
        });
    },
    initTable() {
      let temp = this;
      this.table = $("#customersTable").DataTable({
        ordering: false,
        info: true,
        destroy: true,
        responsive: true,
        // scrollY: "450px",
        scrollCollapse: true,
        searching: true,
        lengthMenu: [
          [5, 10, 25, 50, 100],
          [5, 10, 25, 50, 100],
        ],
        columnDefs: [
          {
            targets: -1,
            orderable: false,
          },
        ],

        pagingType: "full_numbers",
        language: {
          paginate: {
            previous: "<i class='fas fa-angle-left'></i>",
            next: "<i class='fas fa-angle-right'></i>",
            first: "<i class='fas fa-angle-double-left'></i>",
            last: "<i class='fas fa-angle-double-right'></i>",
          },
          search: "",
          searchPlaceholder: "Search ",
        },
        initComplete: function () {
          var column = this.api().column(3);
          column
            .data()
            .unique()
            .sort()
            .each(function (d, j) {
               console.log(d);
              console.log(j);
              //   select.append('<option value="' + d + '">' + d + "</option>");
                console.log(temp.levels);
              temp.levels.push({ label: d, code: d });
            });
        },
      });
    },
    changeLevelFilter() {
      console.log(this.level);
      this.table.column(3).search(this.level).draw();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/doom_yoga/admin/customers/List.vue